/** Email verification — V3 R5. Activates the owner and their workspace. */

import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';
import { AuthLayout } from './AuthLayout';
import { ApiError, api } from '@/lib/api';

export function VerifyEmailPage() {
  const { token } = useParams();
  const [state, setState] = useState<'working' | 'done' | 'failed'>('working');
  const [message, setMessage] = useState('');

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        await api.get(`/auth/verify-email/${token}`);
        if (!cancelled) setState('done');
      } catch (err) {
        if (cancelled) return;
        setMessage(err instanceof ApiError ? err.message : 'That link could not be verified.');
        setState('failed');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <AuthLayout title="Email verification">
      <div className="flex flex-col items-center gap-3 text-center" data-testid="verify-result">
        {state === 'working' && <Loader2 className="size-8 animate-spin vt-muted" />}
        {state === 'done' && (
          <>
            <CheckCircle2 className="size-8 text-[var(--accent)]" />
            <p className="text-[13px]">Verified. Your workspace is active.</p>
            <Link to="/login" className="text-[13px] text-[var(--accent)] hover:underline">
              Sign in
            </Link>
          </>
        )}
        {state === 'failed' && (
          <>
            <XCircle className="size-8 text-[var(--danger)]" />
            <p className="text-[13px]">{message}</p>
            <Link to="/login" className="text-[13px] text-[var(--accent)] hover:underline">
              Back to sign in
            </Link>
          </>
        )}
      </div>
    </AuthLayout>
  );
}
